// Gegenereerd door scripts/proto-1-schil.mjs uit prototype/app.js.
// Het gedrag van de schil: de uitklappanelen in de navigatie en de laden.
(function () {
  function closeMenus() {
    document
      .querySelectorAll("[data-menu-drawer],[data-facet-drawer],[data-cart-drawer]")
      .forEach(function (d) { d.setAttribute("data-open", "false"); });
    document.querySelectorAll(".nav__panel").forEach(function (p) {
      p.setAttribute("data-open", "false");
    });
    document.querySelectorAll("[data-menu]").forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;

    // Uitklappanelen in de hoofdnavigatie.
    var menuBtn = t.closest("[data-menu]");
    if (menuBtn) {
      var panel = menuBtn.parentElement.querySelector(".nav__panel");
      var open = panel.getAttribute("data-open") === "true";
      closeMenus();
      panel.setAttribute("data-open", String(!open));
      menuBtn.setAttribute("aria-expanded", String(!open));
      return;
    }
    // Ergens anders klikken sluit een openstaand paneel.
    if (!t.closest(".nav__panel")) {
      document.querySelectorAll(".nav__panel[data-open='true']").forEach(function (p) {
        p.setAttribute("data-open", "false");
        var b = p.parentElement.querySelector("[data-menu]");
        if (b) b.setAttribute("aria-expanded", "false");
      });
    }

    var opener = t.closest("[data-open-menu]");
    if (opener) {
      document.querySelector("[data-menu-drawer]").setAttribute("data-open", "true");
      // Kwam de klik van het zoek-icoon, zet de cursor dan direct in het veld.
      if (opener.hasAttribute("data-focus-search")) {
        var f = document.getElementById("q-mobile");
        if (f) setTimeout(function () { f.focus(); }, 60);
      }
      return;
    }
    if (t.closest("[data-close-menu]")) {
      document.querySelector("[data-menu-drawer]").setAttribute("data-open", "false");
      return;
    }
    if (t.closest("[data-open-facets]")) {
      document.querySelector("[data-facet-drawer]").setAttribute("data-open", "true");
      return;
    }
    if (t.closest("[data-close-facets]")) {
      document.querySelector("[data-facet-drawer]").setAttribute("data-open", "false");
      return;
    }
  });


  // ── Zoeksuggesties ─────────────────────────────────────────────────────
  // Shopify heeft hier een eigen eindpunt voor, /search/suggest.json, dus
  // hier is geen app voor nodig. Het geeft producten en zoektermen terug; de
  // zoektermen zijn wat de bezoeker waarschijnlijk bedoelde ("arse" wordt
  // "arsenal fc"), en die zijn bij een typefout meer waard dan de producten.
  //
  // Alles gaat met textContent het paneel in en nooit met innerHTML. Een
  // productnaam is gegevens, geen opmaak, en die komen hier langs een pad dat
  // met de zoekterm van de bezoeker begint.
  document.querySelectorAll("[data-zoekveld]").forEach(function (veld) {
    var paneel = document.getElementById(veld.getAttribute("aria-controls"));
    if (!paneel) return;

    var euro = new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" });
    var wacht = null;
    var lopend = null;
    var keuze = -1;

    function sluit() {
      paneel.hidden = true;
      paneel.textContent = "";
      veld.setAttribute("aria-expanded", "false");
      keuze = -1;
    }

    function rijen() {
      return Array.prototype.slice.call(paneel.querySelectorAll("[data-rij]"));
    }

    function markeer(i) {
      var r = rijen();
      if (!r.length) return;
      keuze = ((i % r.length) + r.length) % r.length;
      r.forEach(function (el, n) {
        var aan = n === keuze;
        el.toggleAttribute("data-op", aan);
        el.setAttribute("aria-selected", aan ? "true" : "false");
      });
      r[keuze].scrollIntoView({ block: "nearest" });
    }

    function kop(tekst) {
      var d = document.createElement("div");
      d.className = "suggest__kop";
      d.textContent = tekst;
      return d;
    }

    function optie(href, klasse) {
      var a = document.createElement("a");
      a.className = klasse;
      a.href = href;
      a.setAttribute("data-rij", "");
      a.setAttribute("role", "option");
      a.setAttribute("aria-selected", "false");
      return a;
    }

    function zoekUrl(term) {
      return "/search?type=product&q=" + encodeURIComponent(term);
    }

    function toon(res, term) {
      var producten = res.products || [];
      var termen = res.queries || [];
      paneel.textContent = "";

      if (!producten.length && !termen.length) {
        var leeg = document.createElement("p");
        leeg.className = "suggest__leeg";
        leeg.textContent = "Geen shirt gevonden voor “" + term + "”.";
        paneel.appendChild(leeg);
      }

      if (termen.length) {
        paneel.appendChild(kop("Bedoel je"));
        termen.slice(0, 3).forEach(function (q) {
          var a = optie(zoekUrl(q.text), "suggest__rij suggest__term");
          var n = document.createElement("span");
          n.className = "suggest__naam";
          n.textContent = q.text;
          a.appendChild(n);
          paneel.appendChild(a);
        });
      }

      if (producten.length) {
        paneel.appendChild(kop("Shirts"));
        producten.forEach(function (pr) {
          var a = optie(pr.url, "suggest__rij");
          if (pr.image) {
            var img = document.createElement("img");
            img.className = "suggest__foto";
            img.src = pr.image + (pr.image.indexOf("?") > -1 ? "&" : "?") + "width=92";
            img.alt = "";
            img.loading = "lazy";
            a.appendChild(img);
          }
          var t = document.createElement("span");
          t.className = "suggest__tekst";
          var n = document.createElement("span");
          n.className = "suggest__naam";
          n.textContent = pr.title;
          var pz = document.createElement("span");
          pz.className = "suggest__prijs";
          pz.textContent = pr.available
            ? euro.format(Number(pr.price))
            : "Uitverkocht";
          t.appendChild(n);
          t.appendChild(pz);
          a.appendChild(t);
          paneel.appendChild(a);
        });
        var alles = optie(zoekUrl(term), "suggest__alles");
        alles.textContent = "Alle resultaten voor “" + term + "”";
        paneel.appendChild(alles);
      }

      paneel.hidden = false;
      veld.setAttribute("aria-expanded", "true");
      keuze = -1;
    }

    function haal(term) {
      if (lopend) lopend.abort();
      lopend = new AbortController();
      var url =
        "/search/suggest.json?q=" + encodeURIComponent(term) +
        "&resources[type]=product,query&resources[limit]=5" +
        "&resources[options][unavailable_products]=last";
      fetch(url, { signal: lopend.signal, headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          if (veld.value.trim() !== term) return; // ingehaald door nieuwer typewerk
          toon((d.resources && d.resources.results) || {}, term);
        })
        .catch(function () { /* afgebroken of offline: laat het paneel met rust */ });
    }

    veld.addEventListener("input", function () {
      var term = veld.value.trim();
      clearTimeout(wacht);
      // Onder de twee tekens levert het eindpunt vrijwel de hele winkel op.
      if (term.length < 2) { sluit(); return; }
      wacht = setTimeout(function () { haal(term); }, 180);
    });

    veld.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !paneel.hidden) {
        e.stopPropagation(); // eerst het paneel, pas daarna de laden
        sluit();
        return;
      }
      if (paneel.hidden) return;
      if (e.key === "ArrowDown") { e.preventDefault(); markeer(keuze + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); markeer(keuze - 1); }
      else if (e.key === "Enter" && keuze > -1) {
        e.preventDefault();
        rijen()[keuze].click();
      }
    });

    veld.addEventListener("focus", function () {
      if (veld.value.trim().length >= 2 && paneel.hidden) haal(veld.value.trim());
    });

    document.addEventListener("click", function (e) {
      if (!paneel.contains(e.target) && e.target !== veld) sluit();
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMenus();
  });

  // ── Collectiepagina ────────────────────────────────────────────────────
  // Elke wijziging in een filter of in het sorteermenu verstuurt het formulier.
  // Zo komt de keuze in de URL, en dat is wat iemand kopieert of opslaat.
  document.addEventListener("change", function (e) {
    var form = e.target.closest("[data-filter-form]");
    if (!form) return;
    // De paginering hoort niet mee: na het wijzigen van een filter wil je
    // terug naar pagina 1 en niet naar pagina 4 van een kleinere uitkomst.
    var p = form.querySelector("[name='page']");
    if (p) p.remove();
    form.submit();
  });

  // De filterkolom van de la staat verborgen in de pagina en wordt hierheen
  // verplaatst, zodat hij maar één keer door Liquid opgebouwd hoeft te worden.
  var bron = document.querySelector("[data-facets-bron]");
  var doel = document.querySelector("[data-facets-mobile]");
  if (bron && doel) {
    doel.appendChild(bron.firstElementChild || bron);
    bron.remove();
  }

  // ── Productpagina ──────────────────────────────────────────────────────
  // Een maat kiezen zet het variant-id in het formulier. Zonder dit script
  // blijft de eerste leverbare maat staan, dus kopen werkt dan nog steeds.
  document.addEventListener("click", function (e) {
    var maat = e.target.closest("[data-size-pick]");
    if (maat && !maat.disabled) {
      document.querySelectorAll("[data-size-pick]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === maat));
      });
      var veld = document.querySelector("[data-variant-id]");
      if (veld && maat.dataset.variant) veld.value = maat.dataset.variant;
      var prijs = document.querySelector("[data-prijs]");
      if (prijs && maat.dataset.prijs) prijs.textContent = maat.dataset.prijs;
      return;
    }

    // Miniatuur in de galerij.
    var thumb = e.target.closest("[data-slide]");
    if (thumb) {
      var groot = document.querySelector("[data-main-img]");
      if (groot) groot.src = thumb.dataset.src;
      document.querySelectorAll("[data-slide]").forEach(function (b) {
        b.setAttribute("aria-current", String(b === thumb));
      });
      return;
    }

    // De plakkende knop onderaan koopt hetzelfde als de gewone knop.
    if (e.target.closest("[data-sticky-add]")) {
      var form = document.querySelector("[data-koopformulier]");
      if (form) form.submit();
    }
  });

  // De plakkende koopknop verschijnt zodra de gewone knop uit beeld is.
  (function () {
    var knop = document.querySelector("[data-add]");
    var balk = document.querySelector("[data-sticky-buy]");
    if (!knop || !balk || !("IntersectionObserver" in window)) return;
    var prijs = document.querySelector("[data-prijs]");
    var doel = document.querySelector("[data-sticky-price]");
    if (prijs && doel) doel.textContent = prijs.textContent;
    new IntersectionObserver(
      function (rijen) { balk.setAttribute("data-show", String(!rijen[0].isIntersecting)); },
      { rootMargin: "0px 0px -40px 0px" }
    ).observe(knop);
  })();

  // De rijen met verwante shirts. Die worden opgehaald in plaats van
  // meegestuurd, omdat de club in Shopify een tag is en Liquid daar niet op kan
  // filteren. Lukt het ophalen niet, dan blijft de rij verborgen: een lege rij
  // met een kop erboven is slechter dan geen rij.
  document.querySelectorAll("[data-rail]").forEach(function (rail) {
    fetch(rail.dataset.bron, { headers: { "X-Requested-With": "fetch" } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doel = rail.querySelector("[data-rail-doel]");
        var hulp = document.createElement("div");
        hulp.innerHTML = html;
        var kaarten = [].slice.call(hulp.querySelectorAll(".card")).filter(function (k) {
          // Het shirt waar je al naar kijkt hoort er niet bij te staan.
          return k.getAttribute("href").indexOf("/" + rail.dataset.overslaan) === -1;
        }).slice(0, 4);
        if (!kaarten.length) return;
        kaarten.forEach(function (k) { doel.appendChild(k); });
        rail.hidden = false;
      })
      .catch(function () { /* dan gewoon geen rij */ });
  });

  // ── Clubs A-Z ──────────────────────────────────────────────────────────
  // De letterbalk springt naar de groep. Zonder dit werkt de link ook, maar
  // dan springt de pagina hard in plaats van te schuiven.
  document.addEventListener("click", function (e) {
    var sprong = e.target.closest("[data-jump]");
    if (!sprong) return;
    var doel = document.getElementById("az-" + sprong.dataset.jump);
    if (!doel) return;
    e.preventDefault();
    doel.scrollIntoView({ block: "start", behavior: "smooth" });
  });

  // ── Winkelwagen ────────────────────────────────────────────────────────
  // Het icoon opent de la. Werkt het script niet, dan is het gewoon een link
  // naar /cart, en die pagina bestaat ook. Daarom een link en geen knop.
  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-open-cart]");
    if (open) {
      e.preventDefault();
      document.querySelector("[data-cart-drawer]").setAttribute("data-open", "true");
      return;
    }
    if (e.target.closest("[data-close-cart]")) {
      document.querySelector("[data-cart-drawer]").setAttribute("data-open", "false");
    }
  });
})();
